var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link)?_c('v-icon',{staticClass:"ml-2 mr-2",attrs:{"light":"","color":"black"},on:{"click":_vm.onClick}},[_vm._v(" mdi-download ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }